/* Polite Society quick view — "+" on collection cards opens a product modal (gallery · options · add to cart) */
(function () {
  var cache = {}, modal, lastFocus, hideTimer, openTimer;
  var COLOUR = /^(colou?r|shade)$/i;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, window.psMoneyFormat || (window.theme && theme.moneyFormat) || 'Rs. {{amount_no_decimals}}') : 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN'); } catch (e) { return ''; } }
  function load(handle) { if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); return cache[handle]; }
  function img(url, w) { return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + w + 'x$1$2'); }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'ps-qv'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Quick view'); modal.hidden = true;
    modal.innerHTML = '<div class="ps-qv__overlay" data-qv-close></div><div class="ps-qv__dialog"><button type="button" class="ps-qv__close" data-qv-close aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor"/></svg></button><div class="ps-qv__body" data-qv-body></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) closeModal(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    return modal;
  }
  function openModal(card) {
    var handle = card.dataset.handle; if (!handle) return;
    ensureModal();
    /* the close animation hides the modal on a timer — cancel it, or reopening
       inside that window hides the dialog we are about to show */
    clearTimeout(hideTimer); clearTimeout(openTimer);
    if (!modal.contains(document.activeElement)) lastFocus = document.activeElement;
    card.classList.add('is-quick-loading');
    load(handle).then(function (p) {
      card.classList.remove('is-quick-loading');
      render(card, p);
      modal.hidden = false; document.body.classList.add('ps-qv-open');
      openTimer = setTimeout(function () { modal.classList.add('is-open'); }, 20);
      var c = modal.querySelector('.ps-qv__close'); c && c.focus();
    }).catch(function () { card.classList.remove('is-quick-loading'); });
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    clearTimeout(openTimer);
    modal.classList.remove('is-open'); document.body.classList.remove('ps-qv-open');
    hideTimer = setTimeout(function () { modal.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }
  /* keep Tab inside the dialog while it is open */
  function trapFocus(e) {
    if (e.key !== 'Tab' || !modal || modal.hidden) return;
    var f = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', trapFocus);

  function render(card, p) {
    var body = modal.querySelector('[data-qv-body]');
    var opts = p.options.map(function (o, i) { return { name: o.name || o, position: i + 1, values: o.values || [] }; });
    var single = opts.length === 1 && /default title/i.test(opts[0].values[0] || '');
    var sel = {};
    var active = card.querySelector('[data-ps-swatch].is-active');
    // colour swatch fills from the card (already resolved server-side)
    var swatchColours = {};
    try { var cm = JSON.parse(card.dataset.colours || '{}'); if (cm.values) swatchColours = cm.values; } catch (e) {}
    card.querySelectorAll('[data-ps-swatch]').forEach(function (b) { var sp = b.querySelector('.ps-swatch__color'); if (sp && b.title && !swatchColours[b.title.trim()]) swatchColours[b.title.trim()] = sp.style.background || sp.style.backgroundColor; });
    opts.forEach(function (o) {
      if (COLOUR.test(o.name) && active) { var t = (active.getAttribute('title') || '').trim(); if (o.values.indexOf(t) > -1) sel[o.position] = t; }
      if (o.values.length === 1) sel[o.position] = o.values[0];
      if (sel[o.position] === undefined && !COLOUR.test(o.name)) { /* sizes stay unselected */ }
      if (sel[o.position] === undefined && COLOUR.test(o.name)) sel[o.position] = o.values[0];
    });
    var images = (p.images || []).slice(0, 8);
    var thumbs = images.length > 1
      ? '<div class="ps-qv__thumbs" data-qv-thumbs>' + images.map(function (u, i) {
          return '<button type="button" class="ps-qv__thumb' + (i ? '' : ' is-active') + '" data-qv-thumb="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + esc(img(u, 240)) + '" alt="" loading="lazy"></button>';
        }).join('') + '</div>'
      : '';
    var gallery = '<div class="ps-qv__media">' + '<div class="ps-qv__gallery" data-qv-gallery><div class="ps-qv__track" data-qv-track>' + images.map(function (u, i) {
      return '<div class="ps-qv__slide"><img src="' + esc(img(u, 900)) + '" alt="' + esc(p.title) + (i ? ' — ' + (i + 1) : '') + '" loading="' + (i ? 'lazy' : 'eager') + '"></div>';
    }).join('') + '</div>' + (images.length > 1 ? '<button type="button" class="ps-qv__arrow ps-qv__arrow--prev" data-qv-prev aria-label="Previous image"><svg width="18" height="10" viewBox="0 0 18 10" fill="none"><path d="M6 1 2 5l4 4M2 5h16" stroke="currentColor"/></svg></button><button type="button" class="ps-qv__arrow ps-qv__arrow--next" data-qv-next aria-label="Next image"><svg width="18" height="10" viewBox="0 0 18 10" fill="none"><path d="M12 1l4 4-4 4M16 5H0" stroke="currentColor"/></svg></button><div class="ps-qv__dots" data-qv-dots>' + images.map(function (_, i) { return '<span class="ps-qv__dot' + (i ? '' : ' is-active') + '"></span>'; }).join('') + '</div>' : '') + '</div>' + thumbs + '</div>';
    var info = '<div class="ps-qv__info">' +
      '<h2 class="ps-qv__title">' + esc(p.title) + '</h2>' +
      '<div class="ps-qv__price" data-qv-price>' + money(p.price) + (p.compare_at_price && p.compare_at_price > p.price ? ' <s class="ps-qv__compare">' + money(p.compare_at_price) + '</s>' : '') + '</div>' +
      '<div class="ps-qv__tax ps-body-12 ps-muted">Tax included.</div>';
    if (!single) {
      opts.forEach(function (o) {
        var isColour = COLOUR.test(o.name);
        if (o.values.length === 1 && !isColour) return;
        info += '<div class="ps-qv__group" data-position="' + o.position + '" data-colour="' + (isColour ? '1' : '0') + '"><div class="ps-qv__label">' + esc(o.name) + (isColour ? ' <span class="ps-qv__label-value" data-qv-colour-name>' + esc(sel[o.position] || '') + '</span>' : '') + '</div><div class="ps-qv__values">' +
          o.values.map(function (v) {
            if (isColour) { var bg = swatchColours[v]; return '<button type="button" class="ps-qv__swatch' + (sel[o.position] === v ? ' is-selected' : '') + '" data-value="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '">' + (bg ? '<span class="ps-swatch__color" style="background:' + esc(bg) + '"></span>' : '<span class="ps-qv__swatch-text">' + esc(v) + '</span>') + '</button>'; }
            return '<button type="button" class="ps-qv__value' + (sel[o.position] === v ? ' is-selected' : '') + '" data-value="' + esc(v) + '">' + esc(v) + '</button>';
          }).join('') + '</div></div>';
      });
    }
    info += '<div class="ps-qv__status" data-qv-status></div>' +
      '<button type="button" class="ps-btn ps-btn--block ps-qv__add" data-qv-add>Add to cart</button>' +
      '<a href="' + esc(p.url || ('/products/' + p.handle)) + '" class="ps-link ps-label ps-qv__more">View full details</a>' +
      '</div>';
    body.innerHTML = gallery + info;
    body.__p = p; body.__opts = opts; body.__sel = sel; body.__single = single;
    markAvailability(body); updatePrice(body);
    bindGallery(body);
  }
  function bindGallery(body) {
    var track = body.querySelector('[data-qv-track]'); if (!track) return;
    var dots = body.querySelectorAll('.ps-qv__dot');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }, { passive: true });
    var prev = body.querySelector('[data-qv-prev]'), next = body.querySelector('[data-qv-next]');
    prev && prev.addEventListener('click', function () { go(idx() - 1); });
    next && next.addEventListener('click', function () { go(idx() + 1); });

    /* thumbnail rail */
    var thumbs = [].slice.call(body.querySelectorAll('[data-qv-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.qvThumb, 10) || 0); });
    });
    track.addEventListener('scroll', function () {
      var i = idx();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }, { passive: true });

    /* size the pane to the image's own aspect ratio */
    var gallery = body.querySelector('[data-qv-gallery]');
    var first = track.querySelector('img');
    function setRatio() {
      if (!gallery || !first || !first.naturalWidth) return;
      gallery.style.setProperty('--qv-ratio', first.naturalWidth + ' / ' + first.naturalHeight);
    }
    if (first) { first.complete ? setRatio() : first.addEventListener('load', setRatio, { once: true }); }
  }
  function variantFor(body, sel) {
    return body.__p.variants.find(function (v) { return body.__opts.every(function (o) { return sel[o.position] === undefined || v['option' + o.position] === sel[o.position]; }); });
  }
  function markAvailability(body) {
    var p = body.__p, sel = body.__sel;
    body.querySelectorAll('.ps-qv__group').forEach(function (g) {
      var pos = +g.dataset.position;
      g.querySelectorAll('[data-value]').forEach(function (b) {
        var test = Object.assign({}, sel); test[pos] = b.dataset.value;
        var ok = p.variants.some(function (v) { return v.available && body.__opts.every(function (o) { return test[o.position] === undefined || v['option' + o.position] === test[o.position]; }); });
        b.classList.toggle('is-unavailable', !ok);
      });
    });
  }
  function updatePrice(body) {
    var v = variantFor(body, body.__sel); var el = body.querySelector('[data-qv-price]');
    if (v && el) el.innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s class="ps-qv__compare">' + money(v.compare_at_price) + '</s>' : '');
    // swap gallery to the variant's image if it has one
    if (v && v.featured_image && v.featured_image.src) { var track = body.querySelector('[data-qv-track]'); var imgs = track ? [].slice.call(track.querySelectorAll('img')) : []; var norm = function (u) { return String(u).split('?')[0].replace(/^https?:/, '').replace(/_\d+x(?=\.[a-z]+$)/i, ''); };
      var target = norm(v.featured_image.src);
      var i = imgs.findIndex(function (im) { return norm(im.currentSrc || im.src) === target; }); if (i > -1) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  }
  function add(body) {
    var status = body.querySelector('[data-qv-status]'), btn = body.querySelector('[data-qv-add]');
    var complete = body.__single || body.__opts.every(function (o) { return body.__sel[o.position] !== undefined; });
    if (!complete) { status.textContent = 'Please select a size'; status.classList.remove('is-ok'); return; }
    var v = body.__single ? body.__p.variants[0] : variantFor(body, body.__sel);
    if (!v || !v.available) { status.textContent = 'Sold out in this option'; status.classList.remove('is-ok'); return; }
    status.textContent = 'Adding…'; status.classList.remove('is-ok'); btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
    var fd = new FormData(); fd.append('id', v.id); fd.append('quantity', 1);
    /* Ask for the drawer's own sections back with the add, the same way Dawn's
       product-form.js does, so renderContents() has markup to swap in. */
    if (useDrawer) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        if (res.status && res.status >= 400) { status.textContent = res.description || res.message || 'Could not add'; return; }
        status.textContent = 'Added to bag'; status.classList.add('is-ok');
        if (useDrawer && res.sections) {
          /* close the quickview and hand off to the cart drawer (Arnav, 23 Oct) */
          closeModal();
          setTimeout(function () { drawer.renderContents(res); if (typeof drawer.open === 'function') drawer.open(); }, 260);
        } else {
          setTimeout(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }, 300);
        }
      })
      .catch(function () { btn.disabled = false; status.textContent = 'Could not add — try again'; });
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-ps-quickview]');
    if (qv) { e.preventDefault(); e.stopPropagation(); openModal(qv.closest('.ps-card')); return; }
    if (!modal || modal.hidden) return;
    var body = modal.querySelector('[data-qv-body]');
    var val = e.target.closest('.ps-qv__value, .ps-qv__swatch');
    if (val && modal.contains(val)) {
      e.preventDefault();
      var group = val.closest('.ps-qv__group'), pos = +group.dataset.position;
      group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      val.classList.add('is-selected'); body.__sel[pos] = val.dataset.value;
      var cn = group.querySelector('[data-qv-colour-name]'); if (cn) cn.textContent = val.dataset.value;
      markAvailability(body); updatePrice(body);
      var st = body.querySelector('[data-qv-status]'); if (st) st.textContent = '';
      return;
    }
    if (e.target.closest('[data-qv-add]')) { e.preventDefault(); add(body); }
  });
})();
